import React from 'react'
import { gql, graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import { translate } from 'react-i18next'
import { Form, SelectInput } from '../../UI'
import Loader from '../../UI/Loader'
import { NotificationManager } from 'react-notifications'

import { EXPERTISES } from '../../../constants'
import { validateRequired } from '../../../libs/validation'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class ExpertiseForm extends React.Component {
  state = {
    saving: false,
    items: [
      {
        id: _.uniqueId(),
        expertise: null
      }
    ],
    error: '',
    routeIndex: 7
  }

  componentWillMount() {
    const expertises = _.get(this, 'props.data.User.plannerProfile.expertises', [])
    if (expertises && expertises.length) {
      const items = expertises.map(expertise => {
        return {
          id: _.uniqueId(),
          expertise
        }
      })
      this.setState({ items })
    }
  }

  componentWillReceiveProps(nextProps) {
    const expertises = _.get(this, 'props.data.User.plannerProfile.expertises', [])
    const expertisesNext = _.get(nextProps, 'data.User.plannerProfile.expertises', [])
    if (expertises && expertisesNext && expertises.length !== expertisesNext.length) {
      const items = expertisesNext.map(expertise => {
        return {
          id: _.uniqueId(),
          expertise
        }
      })
      this.setState({ items })
    }
  }

  getLanguageOptions = () => {
    const options = []
    for (let expertise in EXPERTISES) {
      if (EXPERTISES.hasOwnProperty(expertise)) {
        options.push({
          label: EXPERTISES[expertise],
          value: EXPERTISES[expertise]
        })
      }
    }
    return options
  }

  handleSubmit = values => {
    console.log('handleSubmit', values)

    this.props.validate(this.state.routeIndex, true)
    const { t } = this.props

    this.setState({
      saving: true,
      error: ''
    })
    const expertises = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 10) === 'expertise_') {
        if (expertises.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: t('expertise_duplicate_error')
          })
          return
        }
        expertises.push(values[item])
      }
    }
    this.props
      .updatePlannerProfile({
        variables: {
          id: this.props.data.User.plannerProfile.id,
          expertises: expertises
        }
      })
      .then(result => {
        this.setState({
          saving: false
        })
        this.props.data.refetch()
        NotificationManager.success('Expertise updated', 'Success', 5000)
        this.props.history.push('/create-guru-profile/service-description')
      })
      .catch(err => {
        this.setState({
          saving: false
        })
        NotificationManager.error('Error while updating expertise', 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          expertise: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }

    const { saving } = this.state

    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">Special Expertise</div>
        <div className="steps-screen__form-subtitle">{t('special_expertise_description')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {this.state.items.map(el => {
                console.log('el.expertise', el.expertise)
                return (
                  <div key={el.id} className="removable-item-row">
                    <SelectInput
                      options={this.getLanguageOptions()}
                      id={`expertise_${el.id}`}
                      placeholder={t('select_expertise_placeholder')}
                      initialValue={el.expertise}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                    />
                    {this.state.items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_expertise')}
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const updatePlannerProfile = gql`
  mutation($id: ID!, $expertises: [String!]) {
    updatePlannerProfile(id: $id, expertises: $expertises) {
      id
    }
  }
`

const userQuery = gql`
  query userQuery {
    user {
      id
      plannerProfile {
        id
        expertises
      }
    }
  }
`

const TranslatedExpertiseForm = translate('guru')(ExpertiseForm)

export default graphql(updatePlannerProfile, {
  name: 'updatePlannerProfile'
})(
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })
  (withRouter(TranslatedExpertiseForm))
)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/ExpertiseForm.jsx